import type { Schema } from 'effect';

import {
  Productjsonldsyliusshopproductindex,
  Productjsonldsyliusshopproductshowsyliusshopproductshowdetail,
  ProductVariantjsonldsyliusshopproductvariantshowdetail,
} from '../gen/rcprofi';
import {
  Product as ProductShowBase,
  ProductBase as ProductIndexSchema,
  ProductVariant as ProductVariantSchema,
} from '@vs-shop/schemas/branded/ProductSchema';
import { overrideSchema } from '@vs-shop/schemas/openapi/overrideSchema';

/**
 * RcProfi's strict product boundary. The package bases deliberately leave the
 * generated product-tree closure loose; layering their branded fields back on
 * the generated roots preserves the established byte-for-byte decode contract.
 */
export const Product = overrideSchema(
  Productjsonldsyliusshopproductshowsyliusshopproductshowdetail,
  {
    '@id': ProductShowBase.fields['@id'],
    id: ProductShowBase.fields.id,
    code: ProductShowBase.fields.code,
    name: ProductShowBase.fields.name,
    slug: ProductShowBase.fields.slug,
    articles: ProductShowBase.fields.articles,
    banners: ProductShowBase.fields.banners,
  }
).annotate({ identifier: 'Product' });
export type Product = Schema.Schema.Type<typeof Product>;

export const ProductBase = overrideSchema(Productjsonldsyliusshopproductindex, {
  '@id': ProductIndexSchema.fields['@id'],
  id: ProductIndexSchema.fields.id,
  code: ProductIndexSchema.fields.code,
  name: ProductIndexSchema.fields.name,
  slug: ProductIndexSchema.fields.slug,
}).annotate({ identifier: 'ProductBase' });
export type ProductBase = Schema.Schema.Type<typeof ProductBase>;

export const ProductVariant = overrideSchema(
  ProductVariantjsonldsyliusshopproductvariantshowdetail,
  {
    '@id': ProductVariantSchema.fields['@id'],
    code: ProductVariantSchema.fields.code,
    price: ProductVariantSchema.fields.price,
    priceWithoutTax: ProductVariantSchema.fields.priceWithoutTax,
    originalPrice: ProductVariantSchema.fields.originalPrice,
    lowestPriceBeforeDiscount: ProductVariantSchema.fields.lowestPriceBeforeDiscount,
    stockStatus: ProductVariantSchema.fields.stockStatus,
  }
).annotate({ identifier: 'ProductVariant' });
export type ProductVariant = Schema.Schema.Type<typeof ProductVariant>;
